module.exports = __webpack_public_path__ + "52cac3853b1357f7fa767b7609e24002.MP3";